export const MAIL_FORWARDING_TEMPLATE = `# Why Mail Matters Right Now

One of the first practical things to take care of is {{deceased_first_name}} {{deceased_last_name}}'s mail. Right now, you don't yet have the official paperwork USPS requires to redirect it. Understanding what you can do now, and what needs to wait, will help you move forward with confidence.

**Who has the authority to redirect mail:**

- An executor with Letters Testamentary, authorized by the court to manage the estate
- A trustee, authorized under a trust to handle the affairs of the person who passed
- A surviving spouse, depending on state laws and account structure

Here's why this matters: The official mail form requires you to certify you have legal authority. Submitting it without proper paperwork could complicate things later when you do obtain that authority.

This guide will walk you through managing {{deceased_first_name}} {{deceased_last_name}}'s mail while you work toward getting that legal authority. We'll take it one step at a time.

# What You Can Do Right Now

While you wait for your legal documents to come through, there are several steps you can take to keep {{deceased_first_name}} {{deceased_last_name}}'s mail under control. None of these require court paperwork.

**Contact the Accounts You Know About**

This is the most impactful thing you can do right now. Reach out to the banks, insurance companies, credit card issuers, utility providers, and other senders you already know about. Let them know about the passing and ask them to note the account and pause any mailings.

When you call, here's what to say:

> I'm calling to let you know that {{deceased_first_name}} {{deceased_last_name}} has passed away. I'd like to place a note on the account and pause any mailings to their address. I haven't yet been appointed executor, but I wanted to make sure the account is flagged. Can you help me with that?

Most companies will flag the account and stop sending statements or marketing mail. Some may ask you to call back once you have legal documents - that's okay. The important thing right now is making the initial contact.

Keep a record of every call. This will be helpful later when you're ready to formally close or transfer accounts. Use the table below to track your outreach:

| Company / Sender | Phone Number | Date Called | Who You Spoke With | What They Said / Next Steps |
| --- | --- | --- | --- | --- |
| | | | | |
| | | | | |
| | | | | |
| | | | | |

**Mark Unsolicited Mail "Return to Sender - Deceased"**

For junk mail or items from senders you don't recognize, write "Return to Sender - Deceased" on the envelope and place it back in the mailbox. This signals to senders to update their records.

**Reduce Junk Mail**

Elayne has registered {{deceased_first_name}} {{deceased_last_name}} with the DMA Deceased Do Not Contact list on your behalf. This stops most advertising mail within about 90 days.

**Check the Mailbox Regularly**

If the address is accessible, try to check the mailbox at least once a week. Watch for anything time-sensitive, like bills, legal notices, insurance correspondence, or government mail. Set these aside in a safe place.

# Your Next Step

**Once You Have Legal Authority**

Once you receive your Letters Testamentary or Letters of Administration, or complete the Small Estate Affidavit (SEA) process, you'll be able to officially set up USPS mail forwarding for {{deceased_first_name}} {{deceased_last_name}}.

When that happens, come back to your Elayne profile. We'll walk you through your next steps, including what to bring to the post office, what to expect, and how to fill out the form so you can get it done in a single trip.

You've already taken an important step by getting organized now. When the time comes, we'll be right here to help.`;
